export default __webpack_public_path__ + "static/media/m3.694a7b6a.png";